
@switch (filterStyle) {
  @case ("style-1") {
    <style-1-filter-component
      [filtersData]='filtersData'
      [dataContainerService]='dataContainerService'
      [formConfig]='formConfig'
      [showSearchText]='showSearchText'
      [actionButtons]='actionButtons'
      [loading]='loading'
      [filterStyle]='filterStyle'
      (filterChange)='filterChange.emit($event)'
    ></style-1-filter-component>
  }
  @case ('style-01') {
    <style-01-filter-component
      [filtersData]='filtersData'
      [dataContainerService]='dataContainerService'
      [formConfig]='formConfig'
      [showSearchText]='showSearchText'
      [actionButtons]='actionButtons'
      [loading]='loading'
      [filterStyle]='filterStyle'
      (filterChange)='filterChange.emit($event)'
    ></style-01-filter-component>
  }
  @default {
    <style-default-filter-component
      [filtersData]='filtersData'
      [dataContainerService]='dataContainerService'
      [formConfig]='formConfig'
      [showSearchText]='showSearchText'
      [actionButtons]='actionButtons'
      [loading]='loading'
      (filterChange)='filterChange.emit($event)'
    ></style-default-filter-component>
  }
}

@if (loading) {
  <mat-progress-bar mode='indeterminate'></mat-progress-bar>
}